import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'

export const getAllConnections = createAsyncThunk('getAllConnections', async (_, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/connection?type=all`)
        return data.result
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const connectionGetSlice = createSlice({
    name: 'connection',
    initialState: {
        loading: false,
        allConnections: [],
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(getAllConnections.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getAllConnections.fulfilled, (state, action) => {
            state.loading = false;
            state.allConnections = action.payload
        })
        builder.addCase(getAllConnections.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})
export default connectionGetSlice.reducer